import { MCApprovalTypeId } from '@maslul/common-services';
import { Observable } from 'rxjs';

/**
 * אינטרפייס לקולבק בדיקת יבואן
 */
export interface CheckImporterCallback {
  approvalType: MCApprovalTypeId;
  callback: () => Observable<CheckImporterResult>;
}

export class CheckImporterResult {
  isValid: boolean = true;
  message: string = '';
}

/**
 * פרמטרים לבדיקת יבואן
 */
export interface CheckImporterParams {
  userId: string;
  approvalType: string;
  additionalData?: Record<string, any>;
}

/**
 * טיפוסי בדיקות יבואן
 */
export type CheckImporterType =
  | 'COMMUNICATION_PALESTINIAN'
  | 'ECONOMY_QUOTA'
  | 'G2G'
  | 'MEASUREMENTS'
  | 'TRANSPORT_CHECK'
  | 'HEALTH_CHECK';

/**
 * סטטוס בדיקת יבואן
 */
export enum CheckImporterStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
}
